import type { FunctionComponent } from 'react';

export const D3NoMatch: FunctionComponent = () => (
  <div>No D3 Component for that... typo on chartType prop?</div>
);
